// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__oVKGT","clinicsSelect":"TableHeading_clinicsSelect__3jz0V"};